module.exports = __webpack_public_path__ + "img/beach.b0d279fe.png";